const AdminTableWrapper = ({ children, className = "" }) => (
  <div className={`w-full overflow-x-auto ${className}`}>{children}</div>
);

export default AdminTableWrapper;
